//全局注册组件
//左侧一级导航
import Nav from '@/components/Nav.vue';
// 新建分组
import AddGroup from '@/components/AddGroup.vue';
// 移动班级
import MobileClass from '@/components/MobileClass.vue';
// 新增课程
import AddClass from '@/components/AddClass.vue';
// 温馨提示
import Tip from '@/components/tip.vue';
// 新增任务
import AddTask from '@/components/AddTask.vue';
// 编辑任务
import EditTask from '@/components/EditTask.vue';
// 班级列表
import classList from '@/components/classList.vue';
// 编辑班级
import classEdit from '@/components/classEdit.vue';
// 邀请列表
import InviteList from '@/components/InviteList.vue';
//弹窗组件
import Popup from '@/components/header/Popup.vue';
//弹窗组件
import ModelLabel from '@/components/member/ModelLabel.vue';
//取消报名
import cancelRegistration from '@/components/activity/cancelRegistration.vue';
//查看退款
import viewRefund from '@/components/activity/viewRefund.vue';
//查看失败原因
import viewReason from '@/components/activity/viewReason.vue';
//签到码
import checkinCode from '@/components/activity/checkinCode.vue';
//批量导入报名人员
import importPersonnel from '@/components/activity/importPersonnel.vue';
//新增编辑视频
import addVideo from '@/components/activity/addVideo.vue';

//数组存放接收的组件名
const components = [
  { name: "Nav", con: Nav },
  { name: "AddGroup", con: AddGroup },
  { name: "MobileClass", con: MobileClass },
  { name: "AddClass", con: AddClass },
  { name: "Tip", con: Tip },
  { name: "AddTask", con: AddTask },
  { name: "EditTask", con: EditTask },
  { name: "classList", con: classList },
  { name: "classEdit", con: classEdit },
  { name: "InviteList", con: InviteList },
  { name: "Popup", con: Popup },
  { name: "ModelLabel", con: ModelLabel },
  { name: "cancelRegistration", con: cancelRegistration },
  { name: "viewRefund", con: viewRefund },
  { name: "viewReason", con: viewReason },
  { name: "checkinCode", con: checkinCode },
  { name: "importPersonnel", con: importPersonnel },
  { name: "addVideo", con: addVideo }
]
//循环注册组件
const install = function (Vue, opts = {}) {
  components.forEach(component => {
    Vue.component(component.name, component.con);
  });
};

export default {
  install
};
